import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDynamicDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class History extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getDynamicDataList('15-');

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { historyMd, historySlide, historyRecommendFeed, historyAd, isAsync } = content;

        const normalTabsData = historyMd;
        const viewMoreLinkData = (historyMd && historyMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : historyRecommendFeed;
        const mdBannerData = historySlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50153',
                type: 'struct',
                title: '历史子导航数据',
                groupName: 'content',
                translate: 'handleHomeHistoryMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '75193',
                type: 'recommend',
                title: '历史焦点图数据',
                groupName: 'content',
                translate: 'handleHomeHistorySlideInfo',
            };
        }
        const newsStreamChipConfig = {
            id: '90001',
            type: 'recommend',
            title: '历史信息流推荐数据',
            groupName: 'content',
            translate: 'handleHomeHistoryRecommendFeedInfo',
        };

        const moduleData = {
            normalTabsData,
            newsStreamChipConfig,
            feedAd: historyAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.history}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(History);
